<template>
  <div id="app">
    <router-view></router-view>
    
  </div>
  
</template>

<script>
export default {
  name: "app",
  created() {
    document.title = this.$t("title");
  },
  mounted(){
  }
};
</script>
<style scoped lang="stylus">
#app {
}
</style>
<style>
*{
  line-height: 1.2;
}
</style>
